import { render, staticRenderFns } from "./ModalEditTarifSematha.vue?vue&type=template&id=b6f76ea0&scoped=true&"
import script from "./ModalEditTarifSematha.vue?vue&type=script&lang=js&"
export * from "./ModalEditTarifSematha.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditTarifSematha.vue?vue&type=style&index=0&id=b6f76ea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f76ea0",
  null
  
)

export default component.exports